module.exports = __webpack_public_path__ + "static/easiest-to-do-bussiness-with-fall-5db8f43ca46a6bb74f79b1858a5404aa.svg";